import React, { useState } from 'react'
import { ModalActions } from '../../common/modal/Modal'
import { t } from '../../../i18n/i18n'
import { Button, makeStyles, tokens } from '@fluentui/react-components'
import { Text } from '../../common/text/Text'
import { ModalProtectedAssetGoal } from '../../settings/ModalProtectedAssetGoal'
import { DraggableModal } from '../../common/modal/DraggableModal'

const useStyles = makeStyles({
   buttonSpacer: {
      display: 'flex',
      gap: tokens.spacingHorizontalS,
   },
})

type ModalWarningNoProtectedAssetGoalProps = {
   close: () => void
   open: boolean
}
export const ModalWarningNoProtectedAssetGoal = ({ close, open }: ModalWarningNoProtectedAssetGoalProps) => {
   const classes = useStyles()
   const [isWarningModalOpen, setIsWarningModalOpen] = useState(false)
   const [isProtectedAsset, setIsProtectedAsset] = useState(true)

   const onContinue = async (isProtected: boolean) => {
      setIsProtectedAsset(isProtected)
      setIsWarningModalOpen(true)
   }

   return (
      <>
         <DraggableModal open={open} title={t('NoProtectedAssetOrGoal')} onClose={close} noDivider>
            <Text>
               {t('NoProtectedAssetOrGoalInfo')} <br />
               <br /> {t('DoYouWantToAddNow')}
            </Text>
            <ModalActions>
               <Button onClick={close}>{t('NotNow')}</Button>
               <div className={classes.buttonSpacer}>
                  <Button appearance="primary" onClick={() => onContinue(true)}>
                     {t('AddProtectedAsset')}
                  </Button>
                  <Button appearance="primary" onClick={() => onContinue(false)}>
                     {t('AddOrganisationGoal')}
                  </Button>
               </div>
            </ModalActions>
         </DraggableModal>

         <ModalProtectedAssetGoal
            open={isWarningModalOpen}
            closeModal={() => {
               setIsWarningModalOpen(false)
               close()
            }}
            isProtectedAsset={isProtectedAsset}
         />
      </>
   )
}
